export enum LinkSource {
  SLACK = 'slack',
  EMAIL = 'email',
  CALENDAR = 'calendar',
  WEBSITE = 'website',
  OTHER = 'other',
}

export interface Link {
  id: string;
  displayName?: string;
  shortUrl: string;
  targetUrl: string;
  source: LinkSource;
  clickCount: number;
}

export interface Click {
  date: Date;
}
